import styled from 'styled-components'

export const LoggedInWrapper = styled.div`
  display: grid;
  grid-template-columns: 15rem auto;
  min-height: 100vh;
  @media(max-width:768px){
     display:flex;
     flex-direction:column;
  }
`

export const SectionWrapper = styled.section`
  grid-column: 2;
  @media(max-width:768px){
  }
`
export const NavBarWrapper = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  width:247px;
  max-height:200%;
   @media(max-width:768px){
    display:none;
   }
`
export const NavBarWrapperSmallScreen = styled.div`
  display:none;
   @media(max-width:768px){
    display:flex;
   }
`

